<template>
<div id="heating">
    <div class="wrapper">
        <!-- 内容は以下に記述して下さい。 -->
        <app-error-list />
        <!-- 暖房 -->
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="暖房">1</parts-arrow>
                <span>暖房方式を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="暖房方式"
                class="flex_column"
                @click="guideTransition"
                name="hs_houhou"
            >
                <app-radio
                    v-for="value in ['2', '1', '3']"
                    v-model="hs_houhou"
                    :value="value"
                    unit=""
                    :key="'hs_houhou' + value"
                >
                    {{master.hs_houhou[value]}}
                </app-radio>
            </app-box>
        </app-section>
        <div v-if="hs_houhou == 2">
            <app-section v-if="hs_houhou == 2">
                <h3 slot="h3">
                    <parts-arrow category="暖房">2</parts-arrow>
                    <span>
                        <parts-arrow class="line">1</parts-arrow>で「居室のみを暖房する」を選択した場合、主たる居室の暖房設備機器または放熱器の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="暖房設備機器または放熱器の種類"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_type"
                >
                    <div
                        v-for="(valueArray, index) in [['4','5'], ['6','7','10'], ['1','2','3'], ['9', '8']]"
                        class="boxinbox"
                        :key="'hs_ldk_type_box' + index"
                    >
                        <span v-if="valueArray.includes('1')">温水暖房</span>
                        <div>
                            <div
                                v-for="value in valueArray"
                                :key="'hs_ldk_type' + value"
                            >
                                <app-radio
                                    v-model="hs_ldk_type"
                                    :value="value"
                                    unit=""
                                >
                                    {{master.hs_ldk_type[value]}}
                                </app-radio>
                            </div>
                        </div>
                    </div>
                </app-box>
                
                <!-- 主たる居室：ルームエアコン-->
                <app-box
                    v-if="hs_ldk_type == '4'"
                    :available="true"
                    label="エネルギー消費効率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="hs_ldk_aircon_houhou"
                >
                    <app-radio
                        v-for="(name,value) in master.hs_ldk_aircon_houhou"
                        v-model="hs_ldk_aircon_houhou"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_aircon_houhou' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="エネルギー消費効率の区分"
                    name="hs_ldk_aircon_koukouritsu"
                    @click="guideTransition"
                    :available="true"
                    v-if="hs_ldk_aircon_houhou == 2 && hs_ldk_type == 4"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_ldk_aircon_koukouritsu"
                        v-model="hs_ldk_aircon_koukouritsu"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_aircon_koukouritsu' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="小能力時高効率型コンプレッサー"
                    name="hs_ldk_aircon_dualcompressor"
                    @click="guideTransition"
                    :available="true"
                    v-if="hs_ldk_aircon_houhou == 2 && hs_ldk_type == 4"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_ldk_aircon_dualcompressor"
                        v-model="hs_ldk_aircon_dualcompressor"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_aircon_dualcompressor' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <!-- 主たる居室：FF暖房機-->
                <app-box
                    v-if="hs_ldk_type == '5'"
                    :available="true"
                    label="エネルギー消費効率の入力"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_ff_houhou"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_ldk_ff_houhou"
                        v-model="hs_ldk_ff_houhou"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_ff_houhou' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="定格能力におけるエネルギー消費効率"
                    name="hs_ldk_aircon_koukouritsu"
                    :available="true"
                    v-if="hs_ldk_ff_houhou == 2 && hs_ldk_type == 5"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_ldk_ff_e"
                        class=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>

                <!-- 主たる居室：電気ヒーター床暖房-->
                <app-box
                    v-if="hs_ldk_type == '7' && bsc_type != '3'"
                    :available="true"
                    label="敷設率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="hs_ldk_heater_fusetsu_input"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_ldk_heater_fusetsu_input"
                        v-model="hs_ldk_heater_fusetsu_input"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_heater_fusetsu_input' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                    <app-box
                        v-if="hs_ldk_type == '7' && hs_ldk_heater_fusetsu_input=='2' && bsc_type != '3'"
                        :available="true"
                        label="敷設率"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_ldk_heater_fusetsu"
                    >
                        <app-text
                            label=""
                            unit="%"
                            v-model="hs_ldk_heater_fusetsu"
                            class=""
                            subscript="(小数点以下1桁)"
                            :step="0.1"
                        />
                    </app-box>
                <app-box
                    v-if="hs_ldk_type == '7' && hs_ldk_heater_fusetsu_input=='2' && bsc_type != '3'"
                    :available="true"
                    label="仮想床の床面積を除いた敷設率の入力"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_heater_fukinuke"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_ldk_heater_fukinuke"
                        v-model="hs_ldk_heater_fukinuke"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_heater_fukinuke' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="仮想床の床面積を除いた敷設率"
                    name="hs_ldk_heater_fukinuke_fusetsu"
                    v-if="hs_ldk_type == '7' && hs_ldk_heater_fukinuke == 2 && hs_ldk_heater_fusetsu_input=='2' && bsc_type != '3'"
                    :available="true"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_ldk_heater_fukinuke_fusetsu"
                        class=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>
                <app-box
                    v-if="hs_ldk_type == '7'"
                    :available="true"
                    label="上面放熱率（床の断熱）"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_heater_dannetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_ldk_heater_dannetsu"
                        class=""
                        subscript="(整数)"
                        :step="1"
                    />
                    <information-box>
                        上面放熱率の計算には
                        <a
                            href="https://upwhfrate.app.lowenergy.jp"
                            target="_blank"
                            class="target_blank"
                        >
                            床暖房の上面放熱率の簡易計算ツール
                        </a>
                        が利用できます。
                    </information-box>
                </app-box>

                <!-- 主たる居室：ルームエアコンディショナー付温水床暖房機-->
                <app-box
                    v-if="hs_ldk_type == '10' && bsc_type != '3'"
                    :available="true"
                    label="敷設率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="hs_ldk_racfh_fusetsu_input"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_ldk_racfh_fusetsu_input"
                        v-model="hs_ldk_racfh_fusetsu_input"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_racfh_fusetsu_input' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="hs_ldk_type == '10' && hs_ldk_racfh_fusetsu_input=='2' && bsc_type != '3'"
                    :available="true"
                    label="敷設率"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_racfh_fusetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_ldk_racfh_fusetsu"
                        class=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>
                <app-box
                    v-if="hs_ldk_type == '10' && hs_ldk_racfh_fusetsu_input=='2' && bsc_type != '3'"
                    :available="true"
                    label="仮想床の床面積を除いた敷設率の入力"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_racfh_fukinuke"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_ldk_racfh_fukinuke"
                        v-model="hs_ldk_racfh_fukinuke"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_racfh_fukinuke' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="仮想床の床面積を除いた敷設率"
                    :available="true"
                    name="hs_ldk_racfh_fukinuke_fusetsu"
                    v-if="hs_ldk_type == '10' && hs_ldk_racfh_fukinuke == 2 && hs_ldk_racfh_fusetsu_input=='2' && bsc_type != '3'"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_ldk_racfh_fukinuke_fusetsu"
                        class=""
                        subscript=" (小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>
                <app-box
                    v-if="hs_ldk_type == '10'"
                    :available="true"
                    label="上面放熱率（床の断熱）"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_racfh_dannetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_ldk_racfh_dannetsu"
                        class=""
                        subscript="(整数)"
                        :step="1"
                    />
                    <information-box>
                        上面放熱率の計算には
                        <a
                            href="https://upwhfrate.app.lowenergy.jp"
                            target="_blank"
                            class="target_blank"
                        >
                            床暖房の上面放熱率の簡易計算ツール
                        </a>
                        が利用できます。
                    </information-box>
                </app-box>
                <app-box
                    v-if="hs_ldk_type == '10'"
                    :available="true"
                    label="断熱配管"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_racfh_dannetsu_haikan"
                >
                    <app-radio
                        v-for="value in ['2', '1']"
                        v-model="hs_ldk_racfh_dannetsu_haikan"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_racfh_dannetsu_haikan' + value"
                    >
                        {{master.hs_ldk_racfh_dannetsu_haikan[value]}}
                    </app-radio>
                </app-box>

                <!-- 主たる居室：温水床暖房-->
                <app-box
                    v-if="hs_ldk_type == '1' && bsc_type != '3'"
                    :available="true"
                    label="敷設率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="hs_ldk_yuka_fusetsu_input"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_ldk_yuka_fusetsu_input"
                        v-model="hs_ldk_yuka_fusetsu_input"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_yuka_fusetsu_input' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="hs_ldk_type == '1' && hs_ldk_yuka_fusetsu_input=='2' && bsc_type != '3'"
                    :available="true"
                    label="敷設率"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_yuka_fusetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_ldk_yuka_fusetsu"
                        class=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>
                <app-box
                    v-if="hs_ldk_type == '1' && hs_ldk_yuka_fusetsu_input=='2' && bsc_type != '3'"
                    :available="true"
                    label="仮想床の床面積を除いた敷設率の入力"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_yuka_fukinuke"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_ldk_yuka_fukinuke"
                        v-model="hs_ldk_yuka_fukinuke"
                        :value="value"
                        unit=""
                        :key="'hs_ldk_yuka_fukinuke' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="仮想床の床面積を除いた敷設率"
                    name="hs_ldk_yuka_fukinuke_fusetsu"
                    :available="true"
                    v-if="hs_ldk_type == '1' && hs_ldk_yuka_fukinuke == 2 && hs_ldk_yuka_fusetsu_input=='2' && bsc_type != '3'"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_ldk_yuka_fukinuke_fusetsu"
                        class=""
                        subscript=" (小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>
                <app-box
                    v-if="hs_ldk_type == '1'"
                    :available="true"
                    label="上面放熱率（床の断熱）"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_ldk_yuka_dannetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_ldk_yuka_dannetsu"
                        class=""
                        subscript="(整数)"
                        :step="1"
                    />
                    <information-box>
                        上面放熱率の計算には
                        <a
                            href="https://upwhfrate.app.lowenergy.jp"
                            target="_blank"
                            class="target_blank"
                        >
                            床暖房の上面放熱率の簡易計算ツール
                        </a>
                        が利用できます。
                    </information-box>
                </app-box>
                
                <!-- 主たる居室：その他の暖房設備機器-->
                <app-box
                    v-if="hs_ldk_type == '9'"
                    :available="true"
                    label="その他の暖房設備機器の名称"
                    class="flex_column"
                >
                    <app-text
                        label=""
                        unit=""
                        v-model="hs_ldk_other_name"
                        class=""
                        subscript=""
                    />
                </app-box>
            </app-section>
            

            <!-- その他の居室 -->
            <app-section v-if="isSonotanokyoshitu && hs_houhou == 2">
                <h3 slot="h3">
                    <parts-arrow category="暖房">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">1</parts-arrow>で「居室のみを暖房する」を選択した場合、その他の居室の暖房設備機器または放熱器の評価方法を入力して下さい。
                    </span>
                </h3>
                
                <app-box
                    v-if="bsc_kyoshitsu_kousei == 1 || bsc_sonotakyoshitsu != 2"
                    :available="true"
                    label="暖房設備機器または放熱器の種類"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_nldk_type"
                >
                    <div
                        v-for="(valueArray, index) in [['4','5'], ['6','7','10'], ['1','2','3'], ['9', '8']]"
                        class="boxinbox"
                        :key="'hs_nldk_type_box' + index"
                    >
                        <span v-if="valueArray.includes('1')">温水暖房</span>
                        <div>
                            <div
                                v-for="value in valueArray"
                                :key="'hs_nldk_type' + value"
                            >
                                <app-radio
                                    v-model="hs_nldk_type"
                                    :value="value"
                                    unit=""
                                >
                                    {{master.hs_nldk_type[value]}}
                                </app-radio>
                            </div>
                        </div>
                    </div>
                </app-box>

                <!-- その他の居室：ルームエアコン-->
                <app-box
                    v-if="hs_nldk_type == '4'"
                    :available="true"
                    label="エネルギー消費効率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="hs_nldk_aircon_houhou"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_nldk_aircon_houhou"
                        v-model="hs_nldk_aircon_houhou"
                        :value="value"
                        unit=""
                        :key="'hs_nldk_aircon_houhou' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="エネルギー消費効率の区分"
                    @click="guideTransition"
                    name="hs_nldk_aircon_koukouritsu"
                    :available="true"
                    v-if="hs_nldk_aircon_houhou == 2 && hs_nldk_type == 4"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_nldk_aircon_koukouritsu"
                        v-model="hs_nldk_aircon_koukouritsu"
                        :value="value"
                        unit=""
                        :key="'hs_nldk_aircon_koukouritsu' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="小能力時高効率型コンプレッサー"
                    @click="guideTransition"
                    name="hs_nldk_aircon_dualcompressor"
                    :available="true"
                    v-if="hs_nldk_aircon_houhou == 2 && hs_nldk_type == 4"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_nldk_aircon_dualcompressor"
                        v-model="hs_nldk_aircon_dualcompressor"
                        :value="value"
                        unit=""
                        :key="'hs_nldk_aircon_dualcompressor' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <!-- その他の居室：FF暖房機-->
                <app-box
                    v-if="hs_nldk_type == '5'"
                    :available="true"
                    label="エネルギー消費効率の入力"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_nldk_ff_houhou"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_nldk_ff_houhou"
                        v-model="hs_nldk_ff_houhou"
                        :value="value"
                        unit=""
                        :key="'hs_nldk_ff_houhou' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="定格能力におけるエネルギー消費効率"
                    name="hs_nldk_ff_e"
                    :available="true"
                    v-if="hs_nldk_ff_houhou == 2 && hs_nldk_type == 5"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_nldk_ff_e"
                        class=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>

                <!-- その他の居室：電気ヒーター床暖房-->
                <app-box
                    v-if="hs_nldk_type == '7' && bsc_type != '3'"
                    :available="true"
                    label="敷設率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="hs_nldk_heater_fusetsu_input"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_nldk_heater_fusetsu_input"
                        v-model="hs_nldk_heater_fusetsu_input"
                        :value="value"
                        unit=""
                        :key="'hs_nldk_heater_fusetsu_input' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="hs_nldk_type == '7' && hs_nldk_heater_fusetsu_input=='2' && bsc_type != '3'"
                    :available="true"
                    label="敷設率"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_nldk_heater_fusetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_nldk_heater_fusetsu"
                        class=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>
                <app-box
                    v-if="hs_nldk_type == '7'"
                    :available="true"
                    label="上面放熱率（床の断熱）"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_nldk_heater_dannetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_nldk_heater_dannetsu"
                        class=""
                        subscript="(整数)"
                        :step="1"
                    />
                    <information-box>
                        上面放熱率の計算には
                        <a href="https://upwhfrate.app.lowenergy.jp"
                            target="_blank"
                            class="target_blank"
                            >
                            床暖房の上面放熱率の簡易計算ツール
                            </a>
                        が利用できます。
                    </information-box>
                </app-box>

                <!-- その他の居室：ルームエアコンディショナー付温水床暖房機-->
                <app-box
                    v-if="hs_nldk_type == '10' && bsc_type != '3'"
                    :available="true"
                    label="敷設率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="hs_nldk_racfh_fusetsu_input"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_nldk_racfh_fusetsu_input"
                        v-model="hs_nldk_racfh_fusetsu_input"
                        :value="value"
                        unit=""
                        :key="'hs_nldk_racfh_fusetsu_input' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="hs_nldk_type == '10' && hs_nldk_racfh_fusetsu_input=='2' && bsc_type != '3'"
                    :available="true"
                    label="敷設率"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_nldk_racfh_fusetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_nldk_racfh_fusetsu"
                        class=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>
                <app-box
                    v-if="hs_nldk_type == '10'"
                    :available="true"
                    label="上面放熱率（床の断熱）"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_nldk_racfh_dannetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_nldk_racfh_dannetsu"
                        class=""
                        subscript="(整数)"
                        :step="1"
                    />
                    <information-box>
                        上面放熱率の計算には
                        <a
                            href="https://upwhfrate.app.lowenergy.jp"
                            target="_blank"
                            class="target_blank"
                        >
                            床暖房の上面放熱率の簡易計算ツール
                        </a>
                        が利用できます。
                    </information-box>
                </app-box>
                <app-box
                    v-if="hs_nldk_type == '10'"
                    :available="true"
                    label="断熱配管"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_nldk_racfh_dannetsu_haikan"
                >
                    <app-radio
                        v-for="value in ['2', '1']"
                        v-model="hs_nldk_racfh_dannetsu_haikan"
                        :value="value"
                        unit=""
                        :key="'hs_nldk_racfh_dannetsu_haikan' + value"
                    >
                        {{master.hs_nldk_racfh_dannetsu_haikan[value]}}
                    </app-radio>
                </app-box>

                <!-- その他の居室：温水床暖房-->
                <app-box
                    v-if="hs_nldk_type == '1' && bsc_type != '3'"
                    :available="true"
                    label="敷設率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="hs_nldk_yuka_fusetsu_input"
                >
                    <app-radio
                        v-for="(name, value) in master.hs_nldk_yuka_fusetsu_input"
                        v-model="hs_nldk_yuka_fusetsu_input"
                        :value="value"
                        unit=""
                        :key="'hs_nldk_yuka_fusetsu_input' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="hs_nldk_type == '1' && hs_nldk_yuka_fusetsu_input=='2' && bsc_type != '3'"
                    :available="true"
                    label="敷設率"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_nldk_yuka_fusetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_nldk_yuka_fusetsu"
                        class=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                    />
                </app-box>
                <app-box
                    v-if="hs_nldk_type == '1'"
                    :available="true"
                    label="上面放熱率（床の断熱）"
                    class="flex_column"
                    @click="guideTransition"
                    name="hs_nldk_yuka_dannetsu"
                >
                    <app-text
                        label=""
                        unit="%"
                        v-model="hs_nldk_yuka_dannetsu"
                        class=""
                        subscript="(整数)"
                        :step="1"
                    />
                    <information-box>
                        上面放熱率の計算には
                        <a
                            href="https://upwhfrate.app.lowenergy.jp"
                            target="_blank"
                            class="target_blank"
                        >
                            床暖房の上面放熱率の簡易計算ツール
                        </a>
                        が利用できます。
                    </information-box>
                </app-box>
                
                <!-- その他の居室：その他の暖房設備機器-->
                <app-box
                    v-if="hs_nldk_type == '9'"
                    :available="true"
                    label="その他の暖房設備機器の名称"
                    class="flex_column"
                >
                    <app-text
                        label=""
                        unit=""
                        v-model="hs_nldk_other_name"
                        class=""
                        subscript=""
                    />
                </app-box>
            </app-section>
            
            <!-- 温水暖房機を選択したとき -->
            
            <div v-if="isOnsui">
                <app-section>
                    <h3 slot="h3">
                        <parts-arrow category="暖房">4</parts-arrow>
                        <span>
                            <parts-arrow class="line">2</parts-arrow>または<parts-arrow class="line">3</parts-arrow>で「温水暖房」を選択した場合、温水暖房機の評価方法を入力して下さい。
                        </span>
                    </h3>
                    <app-box
                        :available="true"
                        label="温水暖房機の種類"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_netsugen"
                    >
                        <div
                            v-for="(valuesArray, index) in [['3','4','1','2','5','6','7'], ['11','12','13','14']]"
                            class="boxinbox"
                            :key="'hs_onsuiyuka_netsugen_senyo_box' + index"
                        >
                            <span v-if="valuesArray.includes('3')">
                                温水暖房専用型
                            </span>
                            <div>
                                <div
                                    v-for="value in valuesArray"
                                    :key="'hs_onsuiyuka_netsugen_s' + value"
                                >
                                    <app-radio
                                        v-model="hs_onsuiyuka_netsugen_s"
                                        :value="value"
                                        unit=""
                                    >
                                        {{master.hs_onsuiyuka_netsugen_s[value]}}
                                    </app-radio>
                                    <hr v-if="['4', '2', '6'].includes(value)">
                                </div>
                            </div>
                        </div>
                        <information-box title="給湯・温水暖房一体型またはコージェネレーション設備の場合">
                            <p>給湯・温水暖房一体型の場合は、給湯タブで評価方法を入力します。<br />
                            コージェネレーション設備の場合は、コージェネタブで評価方法を入力します。</p>
                        </information-box>
                    </app-box>

                    <!-- 温水暖房機：ガス従来型温水暖房機-->
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '3'"
                        :available="true"
                        label="エネルギー消費効率の入力"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_gas1_houhou"
                    >
                        <app-radio
                            v-for="(name, value) in master.hs_onsuiyuka_gas1_houhou"
                            v-model="hs_onsuiyuka_gas1_houhou"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_gas1_houhou' + value"
                        >
                            {{name}}
                        </app-radio>
                    </app-box>
                    <app-box
                        label="定格能力におけるエネルギー消費効率"
                        name="hs_nldk_ff_e"
                        :available="true"
                        v-if="hs_onsuiyuka_gas1_houhou == 2 && hs_onsuiyuka_netsugen_s == 3"
                    >
                        <app-text
                            label=""
                            unit="%"
                            v-model="hs_onsuiyuka_gas1_e"
                            class=""
                            subscript="(小数点以下1桁)"
                            :step="0.1"
                        />
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '3'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '3'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>

                    <!-- 温水暖房機：ガス潜熱回収型温水暖房機-->
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '4'"
                        :available="true"
                        label="エネルギー消費効率の入力"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_gas2_houhou"
                    >
                        <app-radio
                            v-for="(name, value) in master.hs_onsuiyuka_gas2_houhou"
                            v-model="hs_onsuiyuka_gas2_houhou"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_gas2_houhou' + value"
                        >
                            {{name}}
                        </app-radio>
                    </app-box>
                    <app-box
                        label="定格能力におけるエネルギー消費効率"
                        name="hs_nldk_ff_e"
                        :available="true"
                        v-if="hs_onsuiyuka_gas2_houhou == 2 && hs_onsuiyuka_netsugen_s == 4"
                    >
                        <app-text
                            label=""
                            unit="%"
                            v-model="hs_onsuiyuka_gas2_e"
                            class=""
                            subscript="(小数点以下1桁)"
                            :step="0.1"
                        />
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '4'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2', '1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '4'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>

                    <!-- 温水暖房機：石油従来型温水暖房機-->
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '1'"
                        :available="true"
                        label="エネルギー消費効率の入力"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_oil_houhou"
                    >
                        <app-radio
                            v-for="(name, value) in master.hs_onsuiyuka_oil_houhou"
                            v-model="hs_onsuiyuka_oil_houhou"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_oil_houhou' + value"
                        >
                            {{name}}
                        </app-radio>
                    </app-box>
                    <app-box
                        label="定格能力におけるエネルギー消費効率"
                        name="hs_nldk_ff_e"
                        :available="true"
                        v-if="hs_onsuiyuka_oil_houhou == 2 && hs_onsuiyuka_netsugen_s == 1"
                    >
                        <app-text
                            label=""
                            unit="%"
                            v-model="hs_onsuiyuka_oil_e"
                            class=""
                            subscript="(小数点以下1桁)"
                            :step="0.1"
                        />
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '1'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2', '1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '1'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>


                    <!-- 温水暖房機：石油潜熱回収型温水暖房機-->
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '2'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2', '1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '2'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>
                        
                    <!-- 温水暖房機：電気ヒートポンプ温水暖房機（フロン系冷媒）-->
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '5'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2', '1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '5'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>
                        
                    <!-- 地中熱ヒートポンプ温水暖房機-->               
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '7'"
                        :available="true"
                        label="熱交換器タイプの入力"
                        class="flex_column uq_subbox_18em"
                        @click="guideTransition"
                        name="hs_onsuiyuka_hp_netsukoukan_input"
                    >
                        <app-radio
                            v-for="(name, value) in master.hs_onsuiyuka_hp_netsukoukan_input"
                            v-model="hs_onsuiyuka_hp_netsukoukan_input"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_hp_netsukoukan_input' + value"
                        >
                            {{name}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '7' && hs_onsuiyuka_hp_netsukoukan_input=='2'"
                        :available="true"
                        label="熱交換器タイプ"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_hp_netsukoukan"
                        url="https://house.lowenergy.jp/program#chityunetsu_type_sheet"
                        link-to="tool"
                    >
                        <app-radio
                            v-for="count in 5"
                            v-model="hs_onsuiyuka_hp_netsukoukan"
                            :value="count.toString()"
                            label="1"
                            unit=""
                            :key="count"
                        >
                            {{count}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '7'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2', '1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '7'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>

                    <!-- 温水暖房機：電気ヒーター温水暖房機-->
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '6'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2', '1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '6'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>
                        
                    <!-- 温水暖房機：給湯・温水暖房一体型-->
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '11'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2', '1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '11'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>

                    <!-- 温水暖房機：コージェネレーション-->
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '12'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2', '1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '12'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>
                        
                    <!-- 温水暖房機：その他の温水暖房機 -->
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '13'"
                        :available="true"
                        label="その他の暖房設備機器の名称"
                        class="flex_column"
                    >
                        <app-text
                            label=""
                            unit=""
                            v-model="hs_onsuiyuka_other_name"
                            class=""
                            subscript=""
                        />
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '13'"
                        :available="true"
                        label="断熱配管"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu"
                    >
                        <app-radio
                            v-for="value in ['2', '1']"
                            v-model="hs_onsuiyuka_dannnetu"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu[value]}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hs_onsuiyuka_netsugen_s == '13'"
                        :available="true"
                        label="配管が通過する空間"
                        class="flex_column"
                        @click="guideTransition"
                        name="hs_onsuiyuka_dannnetu_kukaku"
                    >
                        <app-radio
                            v-for="value in ['2','1']"
                            v-model="hs_onsuiyuka_dannnetu_kukaku"
                            :value="value"
                            unit=""
                            :key="'hs_onsuiyuka_dannnetu_kukaku' + value"
                        >
                            {{master.hs_onsuiyuka_dannnetu_kukaku[value]}}
                        </app-radio>
                    </app-box>
                </app-section>
            </div>
        </div>

        <!-- 住戸全体を暖房する -->
        <app-section v-if="hs_houhou == '1'">
            <h3 slot="h3">
                <parts-arrow category="暖房">5</parts-arrow>
                <span>
                    <parts-arrow class="line">1</parts-arrow>で「住戸全体を暖房する」を選択した場合、暖房設備機器の評価方法を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="暖房設備機器の種類"
                class="flex_column"
                @click="guideTransition"
                name="hs_type_1"
            >
                <app-radio
                    v-for="(name, value) in master.hs_type"
                    v-model="hs_type"
                    :value="value"
                    unit=""
                    :key="'hs_type' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="ダクトが通過する空間"
                class="flex_column"
                @click="guideTransition"
                name="hs_dc_duct_dannnetu"
            >
                <app-radio
                    v-for="value in ['2', '1']"
                    v-model="hs_dc_duct_dannnetu"
                    :value="value"
                    unit=""
                    :key="'hs_dc_duct_dannnetu' + value"
                >
                    {{ master.hs_dc_duct_dannnetu[value]}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="VAV方式"
                class="flex_column"
                @click="guideTransition"
                name="hs_dc_vav"
            >
                <app-radio
                    v-for="(name, value) in master.hs_dc_vav"
                    v-model="hs_dc_vav"
                    :value="value"
                    unit=""
                    :key="'hs_dc_vav' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="全般換気機能"
                class="flex_column"
                @click="guideTransition"
                name="hs_dc_general_ventilation"
            >
                <app-radio
                    v-for="value in ['2', '1']"
                    v-model="hs_dc_general_ventilation"
                    :value="value"
                    unit=""
                    :key="'hs_dc_general_ventilation' + value"
                >
                    {{ master.hs_dc_general_ventilation[value]}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="機器の仕様の入力"
                class="flex_column"
                @click="guideTransition"
                name="hs_dc_input"
            >
                <app-radio
                    v-for="(name, value) in master.hs_dc_input"
                    v-model="hs_dc_input"
                    :value="value"
                    unit=""
                    :key="'hs_dc_input' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                v-if="hs_dc_input == 2 || hs_dc_input == 3"
                :available="true"
                label="定格暖房能力試験"
                class="flex_column dc_input"
            >
                <app-text
                    label="能力"
                    unit="W"
                    v-model="hs_dc_rated_capacity"
                    @click="guideTransition"
                    name="hs_dc_rated_capacity"
                    class=""
                    subscript="(整数)"
                    :step="1"
                />
                <app-text
                    label="消費電力"
                    unit="W"
                    v-model="hs_dc_rated_power"
                    @click="guideTransition"
                    name="hs_dc_rated_power"
                    class=""
                    subscript="(整数)"
                    :step="1"
                />
                <app-text
                    label="風量"
                    unit="m3/h"
                    v-model="hs_dc_rated_air_flow"
                    @click="guideTransition"
                    name="hs_dc_rated_air_flow"
                    class=""
                    subscript="(小数点以下1桁)"
                    :step="0.1"
                />
                <app-text
                    label="室内側送風機の消費電力"
                    unit="W"
                    v-model="hs_dc_rated_fan_power"
                    @click="guideTransition"
                    name="hs_dc_rated_fan_power"
                    class=""
                    subscript="(整数)"
                    :step="1"
                />
            </app-box>
            <app-box
                v-if="hs_dc_input == 3"
                :available="true"
                label="中間暖房能力試験"
                class="flex_column dc_input"
            >
                <app-text
                    label="能力"
                    unit="W"
                    v-model="hs_dc_middle_capacity"
                    @click="guideTransition"
                    name="hs_dc_middle_capacity"
                    class=""
                    subscript="(整数)"
                    :step="1"
                />
                <app-text
                    label="消費電力"
                    unit="W"
                    v-model="hs_dc_middle_power"
                    @click="guideTransition"
                    name="hs_dc_middle_power"
                    class=""
                    subscript="(整数)"
                    :step="1"
                />
                <app-text
                    label="風量"
                    unit="m3/h"
                    v-model="hs_dc_middle_air_flow"
                    @click="guideTransition"
                    name="hs_dc_middle_air_flow"
                    class=""
                    subscript="(小数点以下1桁)"
                    :step="0.1"
                />
                <app-text
                    label="室内側送風機の消費電力"
                    unit="W"
                    v-model="hs_dc_middle_fan_power"
                    @click="guideTransition"
                    name="hs_dc_middle_fan_power"
                    class=""
                    subscript="(整数)"
                    :step="1"
                />
            </app-box>
            <app-box
                :available="true"
                label="設計風量の入力"
                class="flex_column"
            >
                <app-radio
                    v-for="(name, value) in master.hs_dc_input_air_flow"
                    v-model="hs_dc_input_air_flow"
                    :value="value"
                    unit=""
                    :key="'hs_dc_input_air_flow' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                v-if="hs_dc_input_air_flow == 2"
                :available="true"
                label="設計風量"
                class="flex_column"
                @click="guideTransition"
                name="hs_dc_air_volume"
            >
                <app-text
                    label=""
                    unit="m3/h"
                    v-model="hs_dc_air_volume"
                    class=""
                    subscript="(整数)"
                    :step="1"
                />
            </app-box>
        </app-section>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版暖房情報入力画面
 * 
 * [算出プロパティ]
 * isSonotanokyoshitu ... その他の居室が存在するか
 * isHikyoshitsu ... 非居室が存在するか
 * isOnsui ... 温水暖房がどこかに採用されているか
 * 他は詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageManualHeating",
    data: () => ({
        //test
        hogeHoge: "0",
        hogeHoge1: "0",
        hogeHoge2: "0",
    }),
    components: {
        
    },
    computed: {
        ...mapGetters('data', {
            data:'getData',
        }),
        ...mapComputedProperties([
            'bsc_type',
            'hs_houhou',
            'hs_ldk_type',
            'hs_ldk_aircon_houhou',
            'hs_ldk_aircon_koukouritsu',
            'hs_ldk_aircon_dualcompressor',
            'hs_ldk_ff_houhou',
            'hs_ldk_ff_e',
            'hs_ldk_heater_fusetsu_input',
            'hs_ldk_heater_fusetsu',
            'hs_ldk_heater_fukinuke',
            'hs_ldk_heater_fukinuke_fusetsu',
            'hs_ldk_heater_dannetsu',
            'hs_ldk_racfh_fusetsu_input',
            'hs_ldk_racfh_fusetsu',
            'hs_ldk_racfh_fukinuke',
            'hs_ldk_racfh_fukinuke_fusetsu',
            'hs_ldk_racfh_dannetsu',
            'hs_ldk_racfh_dannetsu_haikan',
            'hs_ldk_yuka_fusetsu_input',
            'hs_ldk_yuka_fusetsu',
            'hs_ldk_yuka_fukinuke',
            'hs_ldk_yuka_fukinuke_fusetsu',
            'hs_ldk_yuka_dannetsu',
            'hs_ldk_other_name',
            'bsc_kyoshitsu_kousei',
            'bsc_sonotakyoshitsu',
            'bsc_hikyoshitsu',
            'hs_nldk_type',
            'hs_nldk_aircon_houhou',
            'hs_nldk_aircon_koukouritsu',
            'hs_nldk_aircon_dualcompressor',
            'hs_nldk_ff_houhou',
            'hs_nldk_ff_e',
            'hs_nldk_heater_fusetsu_input',
            'hs_nldk_heater_fusetsu',
            'hs_nldk_heater_dannetsu',
            'hs_nldk_racfh_fusetsu_input',
            'hs_nldk_racfh_fusetsu',
            'hs_nldk_racfh_dannetsu',
            'hs_nldk_racfh_dannetsu_haikan',
            'hs_nldk_yuka_fusetsu_input',
            'hs_nldk_yuka_fusetsu',
            'hs_nldk_yuka_dannetsu',
            'hs_nldk_other_name',
            'hs_onsuiyuka_netsugen_s',
            'hs_onsuiyuka_gas1_houhou',
            'hs_onsuiyuka_gas1_e',
            'hs_onsuiyuka_dannnetu',
            'hs_onsuiyuka_dannnetu_kukaku',
            'hs_onsuiyuka_gas2_houhou',
            'hs_onsuiyuka_gas2_e',
            'hs_onsuiyuka_oil_houhou',
            'hs_onsuiyuka_oil_e',
            'hs_onsuiyuka_hp_netsukoukan_input',
            'hs_onsuiyuka_hp_netsukoukan',
            'hs_onsuiyuka_other_name',
            'hs_type',
            'hs_dc_duct_dannnetu',
            'hs_dc_vav',
            'hs_dc_general_ventilation',
            'hs_dc_input',
            'hs_dc_rated_capacity',
            'hs_dc_rated_power',
            'hs_dc_rated_air_flow',
            'hs_dc_rated_fan_power',
            'hs_dc_middle_capacity',
            'hs_dc_middle_power',
            'hs_dc_middle_air_flow',
            'hs_dc_middle_fan_power',
            'hs_dc_input_air_flow',
            'hs_dc_air_volume'
        ]),
        /**
         * @returns Boolean その他の居室が存在するか
         */
        isSonotanokyoshitu(){
            return (this.bsc_kyoshitsu_kousei == 1 || this.bsc_sonotakyoshitsu == 1)
        },
        /**
         * @returns Boolean 非居室が存在するか
         */
        isHikyoshitsu(){
            return (this.bsc_kyoshitsu_kousei == 1 || this.bsc_hikyoshitsu == 1)
        },
        /**
         * @returns Boolean 温水暖房がどこかに採用されているか
         */
        isOnsui(){
            return this.hs_ldk_type == 1 || this.hs_ldk_type == 2 || this.hs_ldk_type == 3 || this.hs_nldk_type == 1 || this.hs_nldk_type == 2 || this.hs_nldk_type == 3
        },
    },
    mixins:[help, master],
    methods:{
        ...mapActions('data', ['update']),
    }
}
</script>

<style scoped>
.dc_input >>> .grid_2 label{
    display: inline-block;
    width: 14em;
}
.uq_subbox_18em>>> .radio_sub_box{
    grid-template-columns: 18em 1fr;
    -ms-grid-columns: 18em 1fr;
}
</style>

